import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '../../contexts/CookieContext';

import './CookieConsent.scss';

const translations = {
  sv: {
    title: 'Vi använder cookies',
    description: 'Vi använder Google Analytics för att förstå hur besökare använder vår webbplats. Detta hjälper oss att förbättra din upplevelse.',
    info: 'Google Analytics samlar in anonym statistik om ditt besök.',
    accept: 'Acceptera cookies',
    reject: 'Endast nödvändiga',
    selectLanguage: 'Välj språk'
  },
  en: {
    title: 'We use cookies',
    description: 'We use Google Analytics to understand how visitors use our website. This helps us improve your experience.',
    info: 'Google Analytics collects anonymous statistics about your visit.',
    accept: 'Accept cookies',
    reject: 'Essential only',
    selectLanguage: 'Select language'
  },
  it: {
    title: 'Utilizziamo i cookie',
    description: 'Utilizziamo Google Analytics per capire come i visitatori utilizzano il nostro sito web. Questo ci aiuta a migliorare la tua esperienza.',
    info: 'Google Analytics raccoglie statistiche anonime sulla tua visita.',
    accept: 'Accetta i cookie',
    reject: 'Solo essenziali',
    selectLanguage: 'Seleziona la lingua'
  }
};

const CookieConsent = ({ onDecision, preSelectedLanguage }) => {
  const { i18n } = useTranslation();
  const { giveConsent, denyConsent, hasConsent } = useCookieConsent();
  const [selectedLanguage, setSelectedLanguage] = useState(preSelectedLanguage || i18n.language || 'it');

  // Update language when preSelectedLanguage changes OR when i18n language changes
  useEffect(() => {
    if (preSelectedLanguage) {
      setSelectedLanguage(preSelectedLanguage);
    } else {
      // Use current i18n language
      setSelectedLanguage(i18n.language);
    }
  }, [preSelectedLanguage, i18n.language]);

  const t = translations[selectedLanguage];

  // Don't show banner if user has already made a decision
  if (hasConsent !== null) {
    return null;
  }

  const handleAccept = () => {
    giveConsent(true);
    if (onDecision) {
      onDecision(selectedLanguage);
    }
  };

  const handleReject = () => {
    denyConsent();
    if (onDecision) {
      onDecision(selectedLanguage);
    }
  };

  return (
    <div className="cookie-consent">
      <div className="cookie-box">
        <div className="cookie-text-content">
          <h2>{t.title}</h2>
          <p className="description">{t.description}</p>
        </div>

        <div className="cookie-actions">
          <button onClick={handleAccept} className="btn-accept">
            {t.accept}
          </button>
          <button onClick={handleReject} className="btn-reject">
            {t.reject}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
